import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, type DialogProps, DialogTitle } from 'base-ui'

import { DirectContactFaxDialogContent } from './DirectContactFaxDialogContent'

export const DirectContactFaxDialog: FC<
  Pick<DialogProps, 'onClose' | 'open'>
> = ({ onClose, open }) => {
  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle onClose={onClose}>
        <FormattedMessage id="contact.directContact.faxDialog.title" />
      </DialogTitle>
      <DialogContent className="flex h-full flex-col place-content-around tablet:px-32">
        <DirectContactFaxDialogContent
          onClick={() => {
            onClose?.({}, 'backdropClick')
          }}
        />
      </DialogContent>
    </Dialog>
  )
}
